import { FC } from 'react';
import { hthHelper } from 'src/services';
import { Marker } from '@react-google-maps/api';
import { typeHTHTerritory, typeHTHFace } from '@monorepo/models';

type propsType = {
    t: typeHTHTerritory;
};

export const HTHInteractiveMapMapNumber: FC<propsType> = ({ t }) => {
    const blocks = new Map<string, typeHTHFace[]>();
    t.faces.forEach(polygon => {
        if (!blocks.has(polygon.block)) {
            blocks.set(polygon.block, []);
        }
        blocks.get(polygon.block)!.push(polygon);
    });

    return (
        <>
        {Array.from(blocks.entries()).map(([block, blockPolygons], blockIndex) => {
            const blockCoordinates = hthHelper.GetBlockCoordinates(blockPolygons, block);
            const blockCenter = hthHelper.GetBlockCenter(blockCoordinates);
            if (blockCoordinates.length < 3) {
                return null;
            }
            if (blockPolygons.length > 1 && blockIndex !== 1) {
                return null;
            }
            return (
                <Marker key={`${block}_${blockIndex}`}
                    position={blockCenter}
                    options={{
                        icon: {
                            path: window.google?.maps?.SymbolPath?.CIRCLE || 0,
                            scale: 16,
                            fillColor: 'white',
                            fillOpacity: 1,
                            strokeColor: 'black',
                            strokeWeight: 3,
                        },
                        label: {
                            className: 'territory-label',
                            color: 'black',
                            fontFamily: 'Arial, Helvetica, sans-serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            text: t.territoryNumber
                        }
                    }}
                />
            );
        })}
        </>
    );
}
